module.exports = __webpack_public_path__ + "img/fuwushiyong.a66ffa63.png";